(function () {
  function initMatrix(root) {
    if (root.dataset.snfReady === 'true') return;

    root.dataset.snfReady = 'true';

    var isTall = root.hasAttribute('data-snf-tall');
    var colourIndex = Number(root.dataset.colourIndex || 0);
    var sectionId = root.dataset.sectionId;
    var productUrl = root.dataset.productUrl;
    var currency = root.dataset.currency || 'CAD';
    var colourButtons = Array.prototype.slice.call(root.querySelectorAll('[data-snf-colour]'));
    var selectedColourElement = root.querySelector('[data-snf-selected-colour]');
    var sizeColourElement = root.querySelector('[data-snf-size-colour]');
    var sizeGrid = root.querySelector('[data-snf-size-grid]');
    var unitPrice = root.querySelector('[data-snf-unit-price]');
    var unitPriceAmount = root.querySelector('[data-snf-unit-price-amount]');
    var unitPriceSizes = root.querySelector('[data-snf-unit-price-sizes]');
    var unitPriceSize = '';
    var chosen = root.querySelector('[data-snf-chosen]');
    var quantityTotal = root.querySelector('[data-snf-total-quantity]');
    var priceTotal = root.querySelector('[data-snf-total-price]');
    var addButton = root.querySelector('[data-snf-add]');
    var errorElement = root.querySelector('[data-snf-error]');
    var quantities = new Map();
    var variantDetails = new Map();
    var selectedOptionIds = [];
    var selectedOptionsElement = root.querySelector('[data-snf-selected-options]');

    try {
      selectedOptionIds = JSON.parse(selectedOptionsElement ? selectedOptionsElement.textContent : '[]');
    } catch (error) {
      selectedOptionIds = [];
    }

    var selectedColour = (colourButtons.find(function (button) {
      return button.getAttribute('aria-pressed') === 'true';
    }) || colourButtons[0]).dataset.snfColour;

    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
        style: 'currency',
        currency: currency
      }).format(cents / 100);
    }

    function updateTallPrice(cents) {
      if (!isTall || !Number.isFinite(cents)) return;
      var priceContainer = document.getElementById('price-' + sectionId);
      var price = priceContainer && priceContainer.querySelector('.price__regular .price-item--regular');
      if (price) price.textContent = money(cents);
    }

    function updateUnitPrice(size) {
      if (!unitPrice || !unitPriceAmount || !unitPriceSizes) return;
      if (size) unitPriceSize = size;
      var rows = Array.prototype.slice.call(sizeGrid.querySelectorAll('[data-snf-size-row]'))
        .filter(function (row) {
          var input = row.querySelector('input');
          return row.dataset.variantId && input && !input.disabled &&
            row.dataset.variantPrice !== '' && Number.isFinite(Number(row.dataset.variantPrice));
        });
      if (!rows.length) {
        unitPrice.hidden = true;
        return;
      }
      var selectedRow = rows.find(function (row) { return row.dataset.size === unitPriceSize; });
      var cents = selectedRow ? Number(selectedRow.dataset.variantPrice) :
        Math.min.apply(null, rows.map(function (row) { return Number(row.dataset.variantPrice); }));
      var sizes = selectedRow ? [selectedRow.dataset.size] :
        rows.filter(function (row) { return Number(row.dataset.variantPrice) === cents; })
          .map(function (row) { return row.dataset.size; });
      unitPriceAmount.textContent = money(cents);
      unitPriceSizes.textContent = '(' + sizes.join(', ') + ')';
      unitPrice.hidden = false;
    }

    function colourQuantity(colour) {
      var total = 0;
      quantities.forEach(function (quantity, id) {
        var details = variantDetails.get(id);
        if (details && details.colour === colour) total += quantity;
      });
      return total;
    }

    function updateColourButtons() {
      colourButtons.forEach(function (button) {
        var isSelected = button.dataset.snfColour === selectedColour;
        var badge = button.querySelector('[data-snf-colour-quantity]');
        var total = colourQuantity(button.dataset.snfColour);

        button.classList.toggle('is-selected', isSelected);
        button.setAttribute('aria-pressed', String(isSelected));
        badge.textContent = String(total);
        badge.hidden = total === 0;
      });
    }

    function updateSummary() {
      var totalQuantity = 0;
      var totalPrice = 0;
      var selected = [];

      quantities.forEach(function (quantity, id) {
        var details = variantDetails.get(id);
        if (!details) return;
        totalQuantity += quantity;
        totalPrice += quantity * Number(details.price || 0);
      });

      colourButtons.forEach(function (button) {
        var total = colourQuantity(button.dataset.snfColour);
        if (total > 0) selected.push(button.dataset.snfColour + ' × ' + total);
      });

      quantityTotal.textContent = String(totalQuantity);
      priceTotal.textContent = money(totalPrice);
      addButton.disabled = totalQuantity === 0;
      chosen.hidden = selected.length === 0;
      chosen.innerHTML = '';

      selected.forEach(function (text) {
        var item = document.createElement('span');
        item.className = 'snf-wholesale-matrix__chosen-item';
        item.textContent = text;
        chosen.appendChild(item);
      });

      updateColourButtons();
    }

    function wireSizeInputs() {
      selectedColourElement.textContent = selectedColour;
      sizeColourElement.textContent = selectedColour;
      Array.prototype.slice.call(sizeGrid.querySelectorAll('[data-snf-size-row]')).forEach(function (label) {
        var input = label.querySelector('input');
        var id = String(label.dataset.variantId || '');
        if (!id || !input) return;

        var quantity = quantities.get(id) || 0;
        variantDetails.set(id, {
          colour: label.dataset.colour,
          size: label.dataset.size,
          price: Number(label.dataset.variantPrice || 0)
        });

        label.classList.toggle('has-quantity', quantity > 0);
        input.value = String(quantity);

        input.addEventListener('focus', function () {
          updateTallPrice(Number(label.dataset.variantPrice));
          updateUnitPrice(label.dataset.size);
        });
        input.addEventListener('input', function () {
          updateTallPrice(Number(label.dataset.variantPrice));
          updateUnitPrice(label.dataset.size);
          var next = Math.max(0, Math.min(999, parseInt(input.value || '0', 10) || 0));
          quantities.set(id, next);
          input.value = String(next);
          label.classList.toggle('has-quantity', next > 0);
          errorElement.hidden = true;
          updateSummary();
        });
      });

      if (isTall) {
        var prices = Array.prototype.slice.call(sizeGrid.querySelectorAll('[data-variant-id]'))
          .filter(function (row) { return row.dataset.variantId; })
          .map(function (row) { return Number(row.dataset.variantPrice); });
        if (prices.length) updateTallPrice(Math.min.apply(null, prices));
      }
      updateUnitPrice();
      updateSummary();
    }


    function showColourMedia(button) {
      var swatch = button.querySelector('.snf-wholesale-matrix__swatch');
      var gallery = document.querySelector('media-gallery');
      if (!swatch || !gallery || typeof gallery.setActiveMedia !== 'function') return;

      if (button.dataset.snfMediaId) {
        var tallSlide = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]')).find(function (slide) {
          return slide.dataset.mediaId.endsWith('-' + button.dataset.snfMediaId);
        });
        if (tallSlide) gallery.setActiveMedia(tallSlide.dataset.mediaId, true);
        return;
      }

      var backgroundImage = window.getComputedStyle(swatch).backgroundImage;
      var match = backgroundImage && backgroundImage.match(/url\(["']?(.*?)["']?\)/);
      if (!match || !match[1]) return;

      var targetName = '';
      try {
        targetName = decodeURIComponent(new URL(match[1], window.location.href).pathname.split('/').pop()).toLowerCase();
      } catch (error) {
        return;
      }

      var matchingSlide = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]')).find(function (slide) {
        return Array.prototype.slice.call(slide.querySelectorAll('img')).some(function (image) {
          var sources = [image.currentSrc, image.src, image.srcset].filter(Boolean).join(' ');
          try {
            sources = decodeURIComponent(sources);
          } catch (error) {
            sources = String(sources);
          }
          return sources.toLowerCase().indexOf(targetName) !== -1;
        });
      });

      if (matchingSlide && matchingSlide.dataset.mediaId) {
        gallery.setActiveMedia(matchingSlide.dataset.mediaId, true);
      }
    }

    function loadColour(button) {
      var previousColour = selectedColour;
      var nextColour = button.dataset.snfColour;
      var nextOptionIds = selectedOptionIds.slice();
      nextOptionIds[colourIndex] = button.dataset.snfOptionValueId;

      selectedColour = nextColour;
      if (unitPrice) unitPrice.hidden = true;
      showColourMedia(button);
      updateColourButtons();
      errorElement.hidden = true;
      root.classList.add('is-loading-options');
      colourButtons.forEach(function (colourButton) {
        colourButton.disabled = true;
      });

      var separator = productUrl.indexOf('?') === -1 ? '?' : '&';
      var requestUrl = productUrl + separator + 'option_values=' + encodeURIComponent(nextOptionIds.join(',')) + '&section_id=' + encodeURIComponent(sectionId);

      fetch(requestUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('The sizes for this colour could not be loaded. Please try again.');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var nextRoot = parsed.querySelector('[data-snf-wholesale-matrix]');
          var nextGrid = nextRoot && nextRoot.querySelector('[data-snf-size-grid]');

          if (!nextGrid) throw new Error('The sizes for this colour could not be loaded. Please try again.');

          sizeGrid.innerHTML = nextGrid.innerHTML;
          selectedOptionIds = nextOptionIds;
          wireSizeInputs();
        })
        .catch(function (error) {
          selectedColour = previousColour;
          updateColourButtons();
          updateUnitPrice();
          var previousButton = colourButtons.find(function (item) {
            return item.dataset.snfColour === previousColour;
          });
          if (previousButton) showColourMedia(previousButton);
          errorElement.textContent = error.message;
          errorElement.hidden = false;
        })
        .finally(function () {
          root.classList.remove('is-loading-options');
          colourButtons.forEach(function (colourButton) {
            colourButton.disabled = false;
          });
        });
    }

    colourButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.dataset.snfColour === selectedColour) return;
        loadColour(button);
      });
    });

    addButton.addEventListener('click', function () {
      var items = [];

      quantities.forEach(function (quantity, id) {
        if (quantity > 0) items.push({ id: Number(id), quantity: quantity, properties: { _snf_order_group: 'blank' } });
      });

      if (!items.length || addButton.disabled) return;

      var spinner = addButton.querySelector('.loading-overlay__spinner');
      var cartDrawer = document.querySelector('cart-drawer');
      var cartNotification = document.querySelector('cart-notification');
      var totalAdded = items.reduce(function (total, item) {
        return total + item.quantity;
      }, 0);
      var payload = { items: items };

      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        payload.sections = cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        });
        payload.sections_url = window.location.pathname;
      } else if (cartNotification) {
        payload.sections = ['cart-notification-button', 'cart-icon-bubble'];
        payload.sections_url = window.location.pathname;
      }

      addButton.disabled = true;
      addButton.classList.add('loading');
      spinner.classList.remove('hidden');
      errorElement.hidden = true;

      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok || body.status) throw new Error(body.description || body.message);
            return body;
          });
        })
        .then(function (response) {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'snf-wholesale-matrix' });
          }

          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            cartDrawer.renderContents(response);
          } else if (cartNotification) {
            ['cart-notification-button', 'cart-icon-bubble'].forEach(function (sectionId) {
              var target = document.getElementById(sectionId);
              var sectionHtml = response.sections && response.sections[sectionId];

              if (!target || !sectionHtml) return;

              if (typeof cartNotification.getSectionInnerHTML === 'function') {
                target.innerHTML = cartNotification.getSectionInnerHTML(sectionHtml);
              }
            });

            var notificationProduct = document.getElementById('cart-notification-product');
            if (notificationProduct) {
              notificationProduct.innerHTML = '';

              var successMessage = document.createElement('p');
              successMessage.className = 'snf-wholesale-matrix__cart-success';
              successMessage.textContent = totalAdded + (totalAdded === 1 ? ' garment added to your cart.' : ' garments added to your cart.');
              notificationProduct.appendChild(successMessage);
            }

            if (typeof cartNotification.open === 'function') cartNotification.open();
          } else {
            errorElement.textContent = 'Your garments were added to the cart.';
            errorElement.hidden = false;
          }

          quantities.clear();
          wireSizeInputs();
        })
        .catch(function (error) {
          errorElement.textContent = error.message;
          errorElement.hidden = false;
        })
        .finally(function () {
          addButton.classList.remove('loading');
          spinner.classList.add('hidden');
          updateSummary();
        });
    });

    wireSizeInputs();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-snf-wholesale-matrix]').forEach(initMatrix);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
